export const GET_CONTAINER_SONG = 'GET_CONTAINER_SONG';
export const REMOVE_UPLOADED_SONG = 'REMOVE_UPLOADED_SONG';
// export const GET_CONTAINER_VIDEO = 'GET_CONTAINER_VIDEO';
// export const REMOVE_UPLOADED_VIDEO = 'REMOVE_UPLOADED_VIDEO';